import React from "react";
import { useNavigate } from "react-router-dom";
import RenewalLayout from "../../components/RenewalLayout";

const shimmer =
  "relative overflow-hidden bg-[#E5E9EB] before:absolute before:inset-0 before:-translate-x-full before:animate-[policyShimmer_1.4s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/70 before:to-transparent";

const Bar = ({ className = "" }) => (
  <span className={`block rounded-md ${shimmer} ${className}`} />
);

const PLAN_CARD_WIDTHS = ["w-20", "w-20", "w-16", "w-20", "w-16"];

const PlanCardSkeleton = ({ priceWidth }) => (
  <div className="flex relative w-[280px] min-w-[280px] h-auto flex-col p-5 pb-4 rounded-[10px] border border-[#DDE2E4] bg-white max767:w-full max767:min-w-full">
    {/* Radio circle — top-right */}
    <div className="absolute top-4 right-4 rtl:right-auto rtl:left-4">
      <Bar className="w-5 h-5 rounded-full" />
    </div>

    {/* Price header */}
    <div className="w-full mb-3">
      <Bar className={`h-6 ${priceWidth}`} />
    </div>

    {/* 3 feature rows: tick + text */}
    <div className="flex flex-col gap-1 w-full mb-1">
      {[["w-3/4", "w-28"], ["w-4/5", "w-32"], ["w-1/2", "w-20"]].map(([tick, text], i) => (
        <div key={i} className="flex gap-2 items-start">
          <Bar className="mt-0.5 flex-shrink-0 w-3 h-3 rounded-full" />
          <Bar className={`h-[14px] ${text}`} />
        </div>
      ))}
    </div>
  </div>
);

const PersonalCyberRenewalSkeleton = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`@keyframes policyShimmer { 100% { transform: translateX(100%); } }`}</style>

      <div className="mainCarDetailsModal pt-[1%] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen ipad:pt-[2%] ipad:h-[93vh] ipad:overflow-y-scroll">
        <RenewalLayout
          policyType="personalCyber"
          show_close_btn={false}
          is_hide_back_btn={false}
          backClickHandler={() => navigate("/renew")}
          is_bottom_sticky_layout={false}
        >
          <div className="flex flex-col items-center p-6 max767:p-0 mx-auto pt-0 py-5 w-full">
            <div className="max767:ml-[0px] max767:mt-0 max767:w-full max767:px-[22px] max767:pt-0 max767:pb-28 w-full max-w-4xl">

              {/* Header — TitleDescription h1 + p + extra subtitle p */}
              <div className="text-center mb-8">
                <Bar className="h-8 w-48 mx-auto mb-2" />
                <Bar className="h-5 w-4/5 mx-auto mb-4" />
                <Bar className="h-5 w-3/4 mx-auto mt-4" />
              </div>

              {/* Plan cards grid — flex-wrap, 5 cards */}
              <div className="flex flex-wrap justify-center gap-3 mb-8 max767:flex-col max767:items-center ipad:gap-4 w-full max-w-[900px] mx-auto">
                {PLAN_CARD_WIDTHS.map((w, i) => (
                  <PlanCardSkeleton key={i} priceWidth={w} />
                ))}
              </div>

              {/* View Benefits button */}
              <div className="flex justify-center mb-6">
                <Bar className="h-9 w-52 rounded-[10px]" />
              </div>

            </div>
          </div>
        </RenewalLayout>
      </div>

      {/* Sticky footer — exact BottomStickyBtnLayout classes */}
      <div className="footer bg-white border-t border-[#E5E9EB] w-full py-2 flex justify-end fixed pr-10 bottom-0 z-[50] max767:w-full max767:px-4 max767:pt-3 max767:pb-[max(2.25rem,calc(env(safe-area-inset-bottom)+1rem))] max767:inset-x-0 ipad:items-center max767:inline-block">
        <div className="flex justify-end pr-0 max767:w-full">
          <Bar className="w-[200px] h-[52px] rounded-[10px] max767:w-full max767:h-[48px]" />
        </div>
      </div>
    </>
  );
};

export default PersonalCyberRenewalSkeleton;
